import { apiClient } from '../config/api';

export interface FeatureFlags {
  create_account_enabled: boolean;
}

const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  create_account_enabled: true,
};

class FeatureFlagsService {
  async getFeatureFlags(): Promise<FeatureFlags> {
    try {
      const response = await apiClient.get<{
        success: boolean;
        data: FeatureFlags;
        timestamp: string;
      }>('/features');

      return response.data.data;
    } catch (error) {
      console.error('Failed to load feature flags, using defaults:', error);
      return DEFAULT_FEATURE_FLAGS;
    }
  }
}

export const featureFlagsService = new FeatureFlagsService();
